import React from 'react';
import PropTypes from 'prop-types';

import BulkReparseJobSearch from './BulkReparseJobSearch';
import BulkReparseJobStatus from './BulkReparseJobStatus';

const BulkReparseTracker = ({ jobId, onJobSearch }) => (
  <>
    <BulkReparseJobSearch onSearch={onJobSearch} />
    <BulkReparseJobStatus jobId={jobId} />
  </>
);

BulkReparseTracker.propTypes = {
  jobId: PropTypes.string,
  onJobSearch: PropTypes.func.isRequired
};

export default BulkReparseTracker;
